import React from 'react'

interface ContentInputField {
  fieldTitle: string;
  fieldTemplate?: "inline" | "default";
  field: React.ReactNode;
}

const CreateContentField = ({
  fieldTitle,
  field,
  fieldTemplate,
}: ContentInputField) => {
  return (
    <div className={fieldTemplate === "inline" ? "row inline" : "row"}>
      <p className="fieldHeader">{fieldTitle}</p>
      <div
        style={{ marginTop: "0", minHeight: "40px" }}
        className="fieldWrapper"
      >
        {field}
      </div>
    </div>
  );
};

export default CreateContentField

